import {
    GET_SKULOOKUPNU_REPORT_REQUEST,
    GET_SKULOOKUPNU_REPORT_SUCCESS,
    GET_SKULOOKUPNU_REPORT_ERROR,
  } from "../actions/types";
  
  export const getSKULookUpReportNu = (state = [], action) => {
    const { type, payload } = action;
    switch (type) {
      case   GET_SKULOOKUPNU_REPORT_REQUEST:
        return {
          loading: true,
        };
      case   GET_SKULOOKUPNU_REPORT_SUCCESS:
        return {
          ...state,
          loading: false,
          payload,
        };
      case   GET_SKULOOKUPNU_REPORT_ERROR:
        return {
          ...state,
          loading: false,
          payload,
        };
  
      default: {
        return state;
      }
    }
  };
  